/// <reference path="../../../../typings/references.d.ts" />
/// <reference path="../dataaccessfactory.ts" />

module PartnershipModule {

    class ActivityFactory extends DataAccessFactory {

        constructor() {
            super()

            this.defaultActions = {
                query: { method: 'GET', params: this.queryParams }
            }

            this.initialize()
        }


        initialize() {
            var resources: Array<PartnershipsModule.DataAccess.Resource> = [
                {
                    name: 'Activities',
                    url: 'admin/activity',
                    actions: {
                        list: {
                            method: 'GET',
                            isArray: true
                        }
                    }
                },
                {
                    name: 'ActivityDetails',
                    url: 'admin/activity/:activityId',
                    params: {
                        activityId: '@id'
                    },
                    actions: {
                        query: {
                            method: 'GET'
                        },
                        update: {
                            method: 'PUT'
                        },
                        create: {
                            method: 'POST',
                            url: 'admin/activity/create'
                        },
						uploadDocument: {
							url: 'admin/activity/:activityId/document',
							method: 'POST'
						},
						deleteDocument: {
							url: 'admin/activity/:activityId/document',
							method: 'DELETE'
						}
                    }
                }
            ]


            this.process(resources)
        }
    }

    new ActivityFactory()
}

